import InfiniteMarquee from 'vanilla-infinite-marquee';

$(function () {
	new InfiniteMarquee({
		element: '#marquee-1',
		speed: 120000,
		direction: 'left',
		spaceBetween: '7vw',
		duplicateCount: 2,
	});
})